import React, {Component} from 'react';
import {NavBar} from "antd-mobile";
import "./style.less";
export default class ApplyInvoice extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }
   
  

    render() {
        return (
            <div className="applyInvoice">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}/>}
                >发票</NavBar>
                <div className="content">
                    <div className="contentBox">
                        {/*<div onClick={()=>this.props.history.push('/invoice','intercity')}>
                            <span>城际开票</span>
                            <i className="icon iconfont icontiaozhuan"/>
                        </div>*/}
                        <div onClick={()=>this.props.history.push('/invoice','city')}>
                            <span>申请开票</span>
                            <i className="icon iconfont icontiaozhuan"/>
                        </div>
                    </div>
                    <div className="contentBox">
                        <div onClick={()=>this.props.history.push('/invoiceHistory')}>
                            <span>开票历史</span>
                            <i className="icon iconfont icontiaozhuan"/>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Invoice/ApplyInvoice/index.js